<template>
    <div class="overtime_rule_wrap" v-loading="loading">
        <div class="page-content">
            <vxe-table :data="tableData" border round>
                <vxe-column field="name" width="328" title="加班规则名称"></vxe-column>
                <vxe-column field="is_approve" title="规则内容">
                    <template #default="{ row }">
                        <div class="ruleText">工作日：{{ jsonRuleText(row.json_rule.work_day) }}</div>
                            <div class="ruleText">休息日：{{ jsonRuleText(row.json_rule.off_day) }}</div>
                            <div class="ruleText">节假日：{{ jsonRuleText(row.json_rule.holiday_day) }}</div>
                    </template>
                </vxe-column>
                <vxe-column title="操作" width="56">
                    <template #default="{ row }">
                        <div class="table-operate-icon">
                            <el-tooltip effect="dark" content="编辑" placement="top"
                                ><i class="iconfont icon-bianji" @click="handleClickEdit(row)"></i
                            ></el-tooltip>
                        </div>
                    </template>
                </vxe-column>
            </vxe-table>
        </div>
        <OvertimeRuleTpl :overtimeTplDialogVisible.sync="overtimeTplDialogVisible" :overtimeDetails="overtimeDetails" @callbackSuccess="getTableData" v-if="overtimeTplDialogVisible" />
    </div>
</template>

<script>
import {GetOvertimeRuleList} from "@/api"
import OvertimeRuleTpl from "./component/overtime_rule_tpl.vue";
export default {
    name: "OvertimeRule",
    components: { OvertimeRuleTpl },
    data() {
        return {
            loading: false,
            tableData: [
                
            ],
            overtimeTplDialogVisible: false,
            overtimeDetails: {}
        };
    },
    created() {
        this.getTableData()
    },
    methods: {
        jsonRuleText(data) {
            let is_use_str = data.is_open == 1 ? "允许加班" : "不允许加班";
            let time_unit_str = `加班时长单位: ${
                data.time_unit == 'day' ? " 天" : data.time_unit == 'ampm' ? " 半天" : " 小时"
            }`;
            let hour_to_day_str = `加班满${data.hour_to_day}小时，计为1天`;
            let calculate_type_str = `计算方式:${
                data.calculation_method == 'approval_time'
                    ? "按审批时长计算"
                    : ""
            }`;
            let return_type_str = `补偿方式:${
                data.compensation_method == "pay"
                    ? `计为加班费以1:${data.compensation_ratio}结算`
                    : data.compensation_method == "comp_leave"
                    ? `计为调休加班时长以1:${data.compensation_ratio}结算为调休假`
                    : "员工自主选择"
            }`;

            return `${is_use_str}，${time_unit_str}，${data.time_unit == 'hour' ? hour_to_day_str + '，' : ''}${calculate_type_str}，${return_type_str}`;
        },
        handleClickEdit(row) {
            this.overtimeDetails = row
            this.overtimeTplDialogVisible = true
        },
        getTableData() {
            this.loading = true
            GetOvertimeRuleList().then(res=> {
                if (res.code === 200) {
                    this.tableData = res.data || [];
                } else {
                    this.$message.error(res.message);
                }
                this.loading = false;
            })
        }
    },
};
</script>

<style lang="scss" scoped>
.overtime_rule_wrap {
    width: 100%;
    height: 100%;
    padding: 16px;
}
</style>
